import { SortTypes } from "../../constants/sort-types";
import { sortCityAscending } from "./sort-city-ascending";
import { sortNameAscending } from "./sort-name-ascending";
import { sortPriceAscending } from "./sort-price-ascending";
import { sortPriceDescending } from "./sort-price-descending";
import { sortSizeAscending } from "./sort-size-ascending";
import { sortSizeDescending } from "./sort-size-descending";

export function getSortFunction(sortOptionId: string) {
	var sortFunction;

	if (sortOptionId === SortTypes.NameAZ) {
		sortFunction = sortNameAscending;
	} else if (sortOptionId === SortTypes.CityAZ) {
		sortFunction = sortCityAscending;
	} else if (sortOptionId === SortTypes.PriceHtL) {
		sortFunction = sortPriceDescending;
	} else if (sortOptionId === SortTypes.PriceLtH) {
		sortFunction = sortPriceAscending;
	} else if (sortOptionId === SortTypes.SqFtHtL) {
		sortFunction = sortSizeDescending;
	} else if (sortOptionId === SortTypes.SqFtLtH) {
		sortFunction = sortSizeAscending;
	}

	return sortFunction;
}
